import { Style } from '@makeswift/runtime/controls';

import { MsVehicleFilterForm } from '~/lib/makeswift/components/vehicle-filter-form/client';
import { runtime } from '~/lib/makeswift/runtime';

runtime.registerComponent(MsVehicleFilterForm, {
  type: 'vehicle-filter-form',
  label: 'Canary / Vehicle Filter Form',
  props: {
    className: Style()
  },
});
